import {Payload} from '../../../../../core/service/payload/payload';
import {WorkflowTriggerPayload} from '../../../../../workflow/task/impl/service/payload/workflowTrigger.payload';

export class EmailSendPayload implements Payload {
    trigger: WorkflowTriggerPayload;
    subject: string;
    toEmail: string;
    content: string;
    documentIds: number[] = [];
    partnerId: number;
}